import { getLocaleCurrencySymbol } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
	name: "currencyLocale",
	standalone: true
})
export class CurrencyLocalePipe implements PipeTransform {
	constructor(private translate: TranslateService) {}

	transform(unformattedCurrency: number): string {
		let formattedLocaleCurrency = "";
		const localeBrowser = this.translate.getBrowserLang();

		if (!unformattedCurrency || !localeBrowser) {
			return "";
		}

		formattedLocaleCurrency += this.localeCurrentSymbol(localeBrowser);
		formattedLocaleCurrency += " ";
		formattedLocaleCurrency += this.localeNumberFormatted(
			unformattedCurrency,
			localeBrowser
		);

		return formattedLocaleCurrency;
	}

	private localeCurrentSymbol(locale: string): string | null {
		return getLocaleCurrencySymbol(locale);
	}

	private localeNumberFormatted(
		unformattedCurrency: number,
		locale: string
	): string {
		return new Intl.NumberFormat(locale, {
			style: "decimal",
			minimumFractionDigits: 2
		}).format(unformattedCurrency);
	}
}
